import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// TODO: Add react-helmet-async when React 19 support is available for SEO meta tags

import Icon from "@mdi/react";
import { mdiAlertOutline, mdiCheckCircleOutline } from "@mdi/js";

import apiClient from "../api/client";
import "../pages/header.css";
import "../pages/Uploads.css";

import logotypeDark from "../assets/dance_locale_3-200h.png";
import danceLocaleIcon from "../assets/logo_fox_map_pin_v4-600h.png";

const CancelDeletion = () => {
    const { token } = useParams();

    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState(""); // "success" or "error"
    const [isValidToken, setIsValidToken] = useState(true);
    const [showSuccess, setShowSuccess] = useState(false);

    useEffect(() => {
        // Check if token exists
        if (!token || token === "cancel-deletion") {
            setMessage("Invalid or missing cancellation token. Please check your email for the correct link.");
            setMessageType("error");
            setIsValidToken(false);
        }
    }, [token]);

    const handleCancelDeletion = async () => {
        setIsLoading(true);
        setMessage("");

        try {
            // Shared api client: adds the X-App-Version dev header on localhost/devMode
            // so the cancel hits the same database the deletion was requested on.
            const response = await apiClient.post("/api/v2/account/cancel-deletion", { token });

            if (response.ok && response.data?.success) {
                setShowSuccess(true);
            } else {
                // The shared client rejects with { ok: false, data: { message, code, ... } } — already flattened
                setMessage(
                    response.data?.message ||
                    "Failed to cancel deletion. Please try again or contact support."
                );
                setMessageType("error");
            }
        } catch (error) {
            console.error("Cancel deletion error:", error);
            setMessage("An error occurred. Please try again later.");
            setMessageType("error");
        } finally {
            setIsLoading(false);
        }
    };

    if (showSuccess) {
        return (
            <div className="dashboard-container branded-bg">
                            {/* TODO: Add SEO meta tags when react-helmet-async supports React 19
                Title: "Deletion Cancelled - Dance Locale" */}

                {/* Header */}
                <div data-role="Header" className="home-header-container">
                    <header className="home-header">
                        <a href="/" className="home-logo1">
                            <img alt="Dance Locale" src={logotypeDark} className="home-image1" />
                            <span className="nav-wordmark">Dance Localé</span>
                        </a>
                        <div className="home-menu1">
                            <a href="/" className="home-text10" style={{ cursor: "pointer", textDecoration: "none" }}>
                                Home
                            </a>
                            <a href="/faq" className="home-text11" style={{ cursor: "pointer", textDecoration: "none" }}>
                                FAQ
                            </a>
                        </div>
                    </header>
                </div>

                {/* Success Content */}
                <div className="dashboard-main">
                    <div className="dashboard-content-wrapper" style={{ maxWidth: "500px" }}>
                        <div className="dashboard-header-card">
                            <div style={{ textAlign: "center", marginBottom: "var(--dl-layout-space-unit)" }}>
                                <Icon
                                    path={mdiCheckCircleOutline}
                                    size={2.5}
                                    color="var(--dl-color-green-500)"
                                />
                            </div>

                            <h1 className="admin-console-title" style={{ color: "var(--dl-color-green-500)" }}>
                                Deletion Cancelled!
                            </h1>
                            <p className="admin-console-description">
                                Great news! Your account deletion has been cancelled successfully. Your account is now
                                active and all your data is safe.
                            </p>

                            <a
                                href="/"
                                className="btn-purple"
                                style={{
                                    width: "100%",
                                    textDecoration: "none",
                                    display: "block",
                                    textAlign: "center",
                                    boxSizing: "border-box",
                                    padding: "14px 16px",
                                    fontSize: "16px",
                                }}>
                                Continue to Dance Locale
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard-container branded-bg">
                        {/* TODO: Add SEO meta tags when react-helmet-async supports React 19
                Title: "Cancel Account Deletion - Dance Locale" */}

            {/* Header */}
            <div data-role="Header" className="home-header-container">
                <header className="home-header">
                    <a href="/" className="home-logo1">
                        <img alt="Dance Locale" src={logotypeDark} className="home-image1" />
                        <span className="nav-wordmark">Dance Localé</span>
                    </a>
                    <div className="home-menu1">
                        <a href="/" className="home-text10" style={{ cursor: "pointer", textDecoration: "none" }}>
                            Home
                        </a>
                        <a href="/faq" className="home-text11" style={{ cursor: "pointer", textDecoration: "none" }}>
                            FAQ
                        </a>
                    </div>
                </header>
            </div>

            {/* Main Content */}
            <div className="dashboard-main">
                <div className="dashboard-content-wrapper" style={{ maxWidth: "500px" }}>
                    <div className="dashboard-header-card">
                        <div style={{ textAlign: "center", marginBottom: "var(--dl-layout-space-unit)" }}>
                            <img
                                src={danceLocaleIcon}
                                alt="Dance Locale"
                                style={{ width: "60px", height: "60px", marginBottom: "var(--dl-layout-space-unit)" }}
                            />
                        </div>

                        <h1 className="admin-console-title" style={{ color: "var(--dl-color-danger)" }}>
                            Cancel Account Deletion
                        </h1>
                        <p className="admin-console-description">
                            Your account is currently scheduled for deletion. You can cancel this deletion to keep your
                            account active.
                        </p>

                        <div
                            className="admin-console-instructions"
                            style={{ backgroundColor: "var(--dl-color-yellow-50)", borderColor: "var(--dl-color-yellow-100)" }}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    fontWeight: "600",
                                    color: "var(--dl-color-status-amber)",
                                    marginBottom: "var(--dl-layout-space-halfunit)",
                                    fontSize: "14px",
                                }}>
                                <Icon path={mdiAlertOutline} size={0.9} style={{ flexShrink: 0 }} />
                                Account Status
                            </div>
                            <div style={{ color: "var(--dl-color-status-amber)", fontSize: "14px", lineHeight: "1.4" }}>
                                Your account will be permanently deleted if you don't cancel the deletion. All your
                                events, data, and settings will be lost forever.
                            </div>
                        </div>

                        {message && (
                            <div
                                style={{
                                    backgroundColor: messageType === "error" ? "var(--dl-color-danger-50)" : "var(--dl-color-green-100)",
                                    border: `1px solid ${messageType === "error" ? "var(--dl-color-danger-200)" : "var(--dl-color-green-200)"}`,
                                    color: messageType === "error" ? "var(--dl-color-warning-red)" : "var(--dl-color-green-700)",
                                    borderRadius: "8px",
                                    padding: "12px",
                                    fontSize: "14px",
                                    marginBottom: "var(--dl-layout-space-unit)",
                                }}>
                                {message}
                            </div>
                        )}

                        {isValidToken && (
                            <button
                                onClick={handleCancelDeletion}
                                className="btn-purple"
                                disabled={isLoading}
                                style={{
                                    width: "100%",
                                    marginBottom: "var(--dl-layout-space-unit)",
                                    background: "var(--dl-color-purple-900)",
                                    padding: "14px 16px",
                                    fontSize: "16px",
                                }}>
                                {isLoading ? "Cancelling..." : "Cancel Account Deletion"}
                            </button>
                        )}

                        <div style={{ textAlign: "center" }}>
                            <a
                                href="/"
                                style={{
                                    color: "var(--dl-color-purple-default)",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                }}>
                                Back to Dance Locale
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CancelDeletion;
